<template>
    <v-dialog
        v-model="show"
        width="500"
        @click:outside="close"
    >
        <v-card v-if="show">
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title class="text-capitalize">
                    Transfer Information
                </v-toolbar-title>
                <v-spacer />
                <v-btn
                    icon
                    color="white"
                    @click="close"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pt-3 pb-6">
                <p class="subtitle-1 font-weight-bold">
                    Your recipient needs to be registered on Kaoshi to receive money.
                </p>

                <ol>
                    <li class="subtitle-1">
                        Enter your recipient's email address so they can receive an invite to register on Kaoshi.
                    </li>
                    <li class="subtitle-1 my-3">
                        If you are sending money to your bank account in a different country,
                        you will need to create a second Kaoshi account for that country.
                        Enter the registered email for the second country to receive an invite to register on Kaoshi.
                    </li>
                    <li class="subtitle-1">
                        If you are sending money to your Dom account,
                        enter your Kaoshi username which you used to log into your account
                    </li>
                </ol>
            </v-card-text>
            <v-card-actions
                v-if="showCheckbox"
                class="px-6"
            >
                <v-checkbox
                    v-model="hideTransferInformationDialog"
                    class="mt-0"
                    label="Ok, Please don't show this again."
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            show: Boolean,
        },
        data() {
            return {
                showCheckbox: true,
            };
        },
        mounted() {
            this.showCheckbox = this.$store.state.transferInformationDialog;
        },
        computed: {
            hideTransferInformationDialog: {
                get() {
                    return !this.$store.state.transferInformationDialog;
                },
                set(value) {
                    this.$store.dispatch('updateTransferInformationDialog', !value);
                },
            },
        },
        methods: {
            close() {
                this.$emit('update:show', false);
            },
        },
    };
</script>
